import styled from 'styled-components'

export const OptionsSection = styled.div`
  margin-bottom: var(--space-400);
  padding-top: var(--space-400);
  border-top: 1px solid var(--border-primary);
`

export const OptionsTitle = styled.h4`
  margin: 0 0 var(--space-200) 0;
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
`

export const OptionsDescription = styled.p`
  margin: 0;
  font-size: var(--font-size-200);
  color: var(--text-secondary);
`
